import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Download, X } from "lucide-react";
import { NeuButton } from "../neu/Neu";
import { IS_STORE_BUILD } from "../../config/storeBuild";

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

const isIos = () =>
  /iphone|ipad|ipod/i.test(window.navigator.userAgent) ||
  (window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);

export const InstallPrompt = () => {
  const { t } = useTranslation();
  const [prompt, setPrompt] = useState(null);
  const [showIosHint, setShowIosHint] = useState(false);
  const standalone = isStandalone();
  const ios = isIos();

  useEffect(() => {
    const handler = (event) => {
      event.preventDefault();
      setPrompt(event);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  // داخل التطبيق الأصلي (TestFlight/المتاجر) لا معنى لزر «تنزيل التطبيق».
  if (IS_STORE_BUILD || standalone || (!prompt && !ios)) return null;

  return (
    <>
      <NeuButton
        data-testid="install-app-btn"
        aria-label={t("app.install")}
        className="px-4 py-2"
        onClick={async () => {
          if (!prompt) return setShowIosHint(true);
          prompt.prompt();
          await prompt.userChoice;
          setPrompt(null);
        }}
      >
        <span className="flex items-center gap-2">
          <Download className="h-4 w-4" />
          <span className="hidden sm:inline">{t("app.install")}</span>
        </span>
      </NeuButton>

      {showIosHint ? (
        <div
          data-testid="ios-install-hint"
          className="fixed inset-0 z-50 flex items-end justify-center bg-black/50 p-4 backdrop-blur-sm sm:items-center"
          onClick={() => setShowIosHint(false)}
        >
          <div
            className="w-full max-w-sm rounded-3xl bg-background p-6 shadow-neu"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-start justify-between gap-3">
              <h2 className="text-base font-bold">{t("app.installIosTitle")}</h2>
              <button data-testid="ios-hint-close" onClick={() => setShowIosHint(false)} aria-label="close">
                <X className="h-5 w-5 text-muted-foreground" />
              </button>
            </div>
            <ol className="mt-4 list-decimal space-y-2 ps-5 text-sm text-muted-foreground">
              <li>{t("app.installIosStep1")}</li>
              <li>{t("app.installIosStep2")}</li>
              <li>{t("app.installIosStep3")}</li>
            </ol>
          </div>
        </div>
      ) : null}
    </>
  );
};
